import { fromJson } from '@bufbuild/protobuf';
import type { NextThinkingModeEntity } from '@platform/timeline';
import {
  NextThinkingModeCompletedSchema,
  NextThinkingModeStartedSchema,
  NextThinkingModeUpdateSchema,
} from '../pb/proto/sem/middleware/next_thinking_mode_pb';
import { registerSem } from '../registry';

registerSem('next.thinking.mode.started', ({ ev, now, convId }) => {
  const pb = fromJson(NextThinkingModeStartedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'next_thinking_mode',
      timestamp: now,
      props: {
        status: 'active',
        mode: pb.data?.mode ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        confidence: pb.data?.confidence ?? undefined,
      },
    } as NextThinkingModeEntity,
  };
});

registerSem('next.thinking.mode.update', ({ ev, now, convId }) => {
  const pb = fromJson(NextThinkingModeUpdateSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'next_thinking_mode',
      timestamp: now,
      props: {
        status: 'active',
        mode: pb.data?.mode ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        confidence: pb.data?.confidence ?? undefined,
      },
    } as NextThinkingModeEntity,
  };
});

registerSem('next.thinking.mode.completed', ({ ev, now, convId }) => {
  const pb = fromJson(NextThinkingModeCompletedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'next_thinking_mode',
      timestamp: now,
      props: {
        status: pb.success === false ? 'error' : 'completed',
        mode: pb.data?.mode ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        confidence: pb.data?.confidence ?? undefined,
        success: pb.success ?? undefined,
        error: pb.error ?? undefined,
      },
    } as NextThinkingModeEntity,
  };
});
